<template>
    <div class="bg-white rounded shadow-card p-5 pb-4">
        <div class="flex justify-between">
            <div>
                <span class="block text-xs text-gray-500 mb-1">Favorecido</span>
                <Favored class="border-none pointer-events-none px-0 py-0" :favored="lot.favored" />
            </div>
            <div class="flex">
                <ButtonIcon
                    v-tippy
                    content="Ver detalhes"
                    class="mr-3"
                    :class="!isSectionDetails ? 'sm:mr-0' : 'sm:mr-5'"
                    :icon="showDetails ? 'far fa-eye-slash' : 'fa-eye'"
                    @click.native="showDetails = !showDetails"
                />
                <ButtonIcon
                    v-if="isSectionDetails"
                    v-tippy
                    content="Remover"
                    class="mr-3 sm:mr-5"
                    :icon="'fa-trash'"
                    :color-icon="'text-red-500'"
                    @click.native="$emit('remove', lot)"
                />
                <ButtonIcon
                    v-if="isSectionDetails"
                    v-tippy
                    content="Editar"
                    :icon="'fa-pen'"
                    @click.native="$emit('edit', lot)"
                />
            </div>
        </div>
        <div class="flex mt-5 justify-between">
            <div>
                <span class="block text-xs text-gray-500 mb-1">Agendado para</span>
                <span class="block text-xs">{{ lot.scheduled.date | smallDate  }} <b>{{ lot.scheduled.description }}</b> </span>
            </div>
            <div>
                <span class="block text-xs text-gray-500 mb-1 text-right">Valor</span>
                <span class="block font-bold leading-none">R$ <span class="text-xl">{{ lot.amount }}</span> </span>
            </div>
        </div>
        <div :class="`transition-all duration-200 bg-gray-50 ${showDetails ? 'mt-4' : ''} ${classDetails}`">
            <div :class="`flex justify-between ${!isSectionDetails ? 'p-3' : 'p-5'}`">
                <div class="mr-3">
                    <div class="mb-3">
                        <span class="block text-xs text-gray-500 mb-1">Banco destinado</span>
                        <span class="block text-xs text-black">{{ lot.bank.number }} - {{ lot.bank.name }}</span>
                    </div>
                    <div class="flex">
                        <div class="mr-4">
                            <span class="block text-xs text-gray-500 mb-1">Agência</span>
                            <span class="block text-xs text-black">{{ lot.bank.agency }}</span>
                        </div>
                        <div>
                            <span class="block text-xs text-gray-500 mb-1">Conta</span>
                            <span class="block text-xs text-black">{{ lot.bank.account.number }}-{{ lot.bank.account.digit }}</span>
                        </div>
                    </div>
                    <div v-if="hasGoal" class="mt-4 ml-1">
                        <span class="block text-xs text-gray-500 mb-1">Finalidade</span>
                        <span class="block text-xs text-black">{{ lot.goal.name }}</span>
                    </div>
                </div>
                <div :class="hasGoal ? 'flex flex-col justify-between' : ''">
                    <div class="mb-4">
                        <span class="block text-xs text-gray-500 mb-1">Descrição</span>
                        <p :class="`block text-xs text-black ${!isSectionDetails ? 'w-auto' : 'sm:w-52 w-40'}`" style="min-height: 25px">
                            {{ lot.description || '--' }}
                        </p>
                    </div>
                    <div>
                        <span class="block text-xs text-gray-500 mb-1">Identificador de cobrança</span>
                        <span class="block text-xs text-black">{{ lot.receiveCode || '--' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonIcon from './ButtonIcon.vue';
import Favored from './Favored.vue';

export default {
    name: "LotItem",
    props: {
        lot: { type: Object },
        isSectionDetails: { type: Boolean, default: true }
    },
    data: () => ({
        showDetails: false
    }),
    computed: {
        classDetails() {
            return this.showDetails ? `${this.hasGoal ? 'h-44': 'h-36'} overflow-auto` : "h-0 overflow-hidden";
        },
        hasGoal() {
            return !!this.lot.goal
        }
    },
    components: { ButtonIcon, Favored }
}
</script>
